import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-2xl px-6 py-24 text-center">
      <p className="mb-3 text-caption font-medium uppercase tracking-widest text-primary">404</p>
      <h1 className="mb-3 font-display text-h1 uppercase text-primary">Seite nicht gefunden</h1>
      <p className="mb-6 text-body-sm text-ink-soft">
        Die angefragte Seite existiert nicht oder wurde verschoben.
      </p>
      <Link to="/" className="text-primary underline">
        Zur Startseite
      </Link>
    </div>
  );
}
